import { gql, useSuspenseQuery } from '@apollo/client';

import { useUserOrgId } from '../../auth/authentication';

const ORGANIZATION_TIMESLOT_ALIGNMENT_MINUTES_QUERY = gql`
    query OrganizationTimeslotAlignmentMinutesQuery {
        currentOrganization {
            id
            timeslotAlignmentMinutes
        }
    }
`;

interface IOrganizationTimeslotAlignmentMinutesQuery {
    currentOrganization: {
        id: string;
        timeslotAlignmentMinutes: number;
    };
}

export const useTimeslotAlignmentMinutes = (): number => {
    const userOrgId = useUserOrgId();

    const { data } = useSuspenseQuery<IOrganizationTimeslotAlignmentMinutesQuery>(
        ORGANIZATION_TIMESLOT_ALIGNMENT_MINUTES_QUERY,
        {
            variables: { org_id: userOrgId },
        },
    );

    return data.currentOrganization.timeslotAlignmentMinutes;
};
